import { REWARD_OFFERING } from "../../constants";
import CompetitionPage from "../../common/components/CompetitionPage";

function SydneyMarathonMain() {
  const offerId = REWARD_OFFERING.sydneyMarathon;

  return (
    <CompetitionPage 
      offerId={offerId}
    />
  );
}

export default SydneyMarathonMain;